module.exports = __webpack_public_path__ + "img/roomcard_level1.a8465b8e.png";